import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageMeta from "@/components/base/PageMeta";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import StatsBanner from "./components/StatsBanner";
import FeatureGrid from "./components/FeatureGrid";
import Testimonials from "./components/Testimonials";
import CTABanner from "./components/CTABanner";
import ArticleLinks from "./components/ArticleLinks";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <PageMeta
        type="website"
        headline="Superbuy Spreadsheet - Trusted Shopping Link Directory"
        description="The most trusted superbuy spreadsheet link directory for verified shopping links across 14 curated categories. Updated daily with QC guides and community reviews."
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <StatsBanner />
        <FeatureGrid />
        <Testimonials />
        <CTABanner />
        <ArticleLinks />
      </main>
      <Footer />
    </div>
  );
}